import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux';
import swal from 'sweetalert';

import { updateDocument, getDocument } from "./api";
import { loaderEnd, loaderStart } from '../../components/loader';
import Wizard from '../Wizard';
import { checkUrl } from "../../shared/strings"

const Step2 = (props) => {
    const navigate = useNavigate()
    // const showAlert = () => {
    //   swal("Application Form Submitted Successfully", "आपने अपना आवेदन सफलता पूर्वक समपर्पित कर दिया है | Your Application is forwarded for verification. you will be informed shortly whether it is complete or some more information required. You will be able to book your slot once your application is complete and found to be Ok ", "success")
    //   setTimeout(() => {
    //     navigate('/step3')
    //   }, 2000);
    // }
    const [migrated, setMigrated] = useState(0)

    const [state, setState] = useState({
        document: "",
        documentPath: "",
    })
    const [status, setStatus] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const handleChange = (e) => {
        delete state.documentPath;
        let _state = { ...state }
        _state[e.target.name] = e.target.files[0]
        setState(_state)
    }

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        loaderStart()
        let res = await getDocument();
        console.log(res);
        if (res.code == 1) {
            if (res.data.status == "INACTIVE") {
                navigate("/application")
            }
            setState({
                documentPath: res.data?.document
            })
            if (res.data?.migrated)
                setMigrated(1)
            setDisabled(props.auth.wizardStatus?.document == "filled" ? true : false)
            if (res.data?.document) {
                setStatus(true)
            }
        }
        loaderEnd()
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (props.auth.wizardStatus.application == "new") {
            swal("Please complete step 1 to proceed.", "", "error")
        }
        else {
            loaderStart()
            let formData = new FormData();
            for (let [key, val] of Object.entries(state)) {
                if (val)
                    formData.append(key, val);
            }
            if (!state.document) {
                formData.append("document", state.documentPath);
            }
            let res = await updateDocument(formData)
            if (res.code == 1) {
                swal("Application Form Submitted Successfully", "आपने अपना आवेदन सफलता पूर्वक समपर्पित कर दिया है | Your Application is forwarded for verification. you will be informed shortly whether it is complete or some more information required. You will be able to book your slot once your application is complete and found to be Ok ", "success")
                    .then((value) => {
                        if (props.auth.wizardStatus?.document != "disabled")
                            navigate('/application')
                    });
            }
            else {
                swal(res.message, "", "error")
            }
            loaderEnd()
        }
    }

    return (
        <>
            <div className="card  application-box">
                <Wizard
                    document={status}
                    title="Document Upload"
                    redirect='/application-form'
                />

                <form onSubmit={handleSubmit}>
                    <div id="applications" className='application-body application-form-box step_form'>
                        <div className='card application-form'>
                            <h2 className="ui_section_title">Upload Forwarded Application</h2>

                            {/* Was 16px red italic centred text — it reads as an error
                                even though it is instruction. Amber notice, left
                                aligned, at a readable size. */}
                            <p className="ui_notice">
                                <i className="fa fa-info-circle" aria-hidden="true"></i>
                                <span>
                                    आवेदक अनिवार्यतः अपने नियंत्री पदाधिकारी / कार्यालय प्रधान से ही
                                    आवेदन अग्रसारित कराकर ही अपलोड करेंगे। किसी अन्य पदाधिकारी द्वारा
                                    अग्रसारित आवेदन पत्र मान्य नहीं होगा। बिना ज्ञापांक और दिनांक के
                                    अग्रसारित आवेदन पत्र अस्वीकृत कर दिया जायेगा।
                                </span>
                            </p>

                            <div className="ui_uploads ui_uploads_single">
                                <div className="ui_upload">
                                    <label className="ui_upload_label" htmlFor="upload_document">
                                        <span className="ui_required">*</span>
                                        Forwarded Application Form / अग्रसारित आवेदन पत्र
                                    </label>
                                    <input
                                        id="upload_document"
                                        name="document"
                                        onChange={(e) => handleChange(e)}
                                        type="file"
                                        className="form-control"
                                        required={state.documentPath ? false : true}
                                        accept="application/pdf"
                                        disabled={disabled}
                                    />
                                    <span className="ui_upload_hint">
                                        PDF only · 4 KB to 5 MB
                                    </span>
                                    {state.documentPath ? (
                                        <a className="ui_upload_view" target="_blank" rel="noreferrer"
                                            href={checkUrl(state.documentPath) ? state.documentPath : process.env.REACT_APP_FILE_URL + state.documentPath}>
                                            <i className="fa fa-check-circle" aria-hidden="true"></i> View uploaded file
                                        </a>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        props.auth.wizardStatus?.document == "new"
                            ?
                            <div className="d-grid gap-2">
                                <button className="ui_btn ui_btn_primary ui_btn_block" type="submit"><i className="fa fa-paper-plane" aria-hidden="true"></i> Upload</button>
                            </div>
                            : null
                    }

                </form>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.Auth
    }
}

export default connect(mapStateToProps)(Step2);
